<template>
    <section class="team-add-student-view">
        <h3>Add Student To Team</h3>
        <div class="input-options">
            <label>
                <span class="visuallyhidden">Name or Email</span>
                <app-input 
                    v-model="query" 
                    placeholder="Name or Email"
                    autofocus/>
            </label>
            <span>or</span>
            <app-button
                :border="false"
                size="large"
                tabindex="1"
                style="float:left"
                @click="showAddBulk = true">Add Bulk</app-button>
        </div>
        <div class="students">
            <student-table
                :items="students"
                :columns="['first_name','last_name','email']"
                :allow-sort="false"
                :handle-click="handleAddStudent"/>
        </div>

        <modal v-model="showAddBulk" size="small">
            <team-add-bulk-students :team_id="team_id" @reload="handleBulk" />
        </modal>
    </section>
</template>
<script>
import { mapActions } from 'vuex'
import Team from '@/store/models/Team'
import Student from '@/store/models/Student'

import StudentTable from '../Student/StudentTable'
import TeamAddBulkStudents from './TeamAddBulkStudents'

export default {
    name: 'team-add-student-view',
    inject: ['modalOptions'],
    components: {
        StudentTable,
        TeamAddBulkStudents
    },
    props: ['team_id'],
    data() {
        return {
            students: [],
            query: '',
            showAddBulk: false
        }
    },
    computed: {
        team() { return Team.query().whereId(this.team_id).withAll().first() }
    },
    methods: {
        ...mapActions(['getStudentParamList', 'addStudentToTeam']),
        getStudentList(query) {
            this.loading = true
            this.getStudentParamList({
                query: query,
                per_page: 5,
                scoped: false
            }).then(students => {
                this.loading = false
                this.students = students
            })
        },
        handleAddStudent(student) {
            const attachStudent = Student.query().whereId(student.id).withAll().first()
            attachStudent.$attach(this.team_id, 'teams', 'addStudentToTeam')
                .then(() => {
                    this.modalOptions.modalOpen = false
                })
            return false
        },
        handleBulk() {
            this.$emit('reload')
            this.modalOptions.modalOpen = false
        }
    },
    watch: {
        query(newValue) {
            this.getStudentList(newValue)
        }
    }
}
</script>

<style lang="stylus" scoped>
.input-options
    display: flex
    justify-content: center
    align-items: center
    label
        flex-grow: 1
    span
        display: block
        padding: 0 10px
</style>
